<template>
	<div id="vx-col w-full mb-base" ref="popupContainer">
		<!--
    <vx-card class="mb-1">
      <div class="vx-row">
        <div class="vx-col mb-2">
          <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })"
            >Nouvelle facture</vs-button
          >
        </div>
        <vs-spacer />
        <div class="vx-col mb-2">
          <vs-button icon-pack="feather" icon="icon-download-cloud" color="dark" @click="exportData(displayedPendingInvoices)">Exporter</vs-button>
        </div>
      </div>
    </vx-card>
	-->
		<FilterCard
			:refreshKey="1"
			:filters="filtersTemplates"
			:showListLength="totalListLength"
			:subtext="filterSubText"
			@filter="handleFilterEmits($event)"
			:actions="actionsTemplates"
			@action="handleActionEmits($event)"
			:onChangeEmit="true"
			@clearAll="resetAllFilter()"
		/>
		<!-- CONTRACT TABLE -->
		<vx-card class="mt-1" style="overflow: auto">
			<div ref="invoicesTable">
				<div v-if="isLoading" class="text-center">
					<circular-loader />
				</div>
				<InvoicesTable
					v-else
					:key="refreshKey"
					:pending_invoices="displayedPendingInvoices"
					:apiUrl="apiUrl"
					@contract-info-popup="displayContractPopup($event)"
					@show-society-popup="displaySocietyPopup($event)"
				/>
			</div>
		</vx-card>
	</div>
</template>

<script>
import Vue from "vue";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import FilterCard from "@/views/filters/FilterCard";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import InvoicesTable from "@/components/tables/InvoicesTable";
import XLSX from "xlsx";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";

// import { Contract } from "@/entities/Contract"

import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import CircularLoader from "../../components/widgets/loader/CircularLoader.vue";

export default {
	name: "InvoicesDashboard",
	mixins: [dbFieldConvertor, utilsMixin],
	components: {
		InvoicesTable,
		FilterCard,
		CircularLoader,
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			selectedContract: null,
			showContractPopup: false,
			showSocietyPopup: false,
			accountmanagerFilter: "",
			commercialFilter: "",
			deliveryFilter: "",
			isSentFilter: false,
			societyFilter: "",
			statusFilter: [],
			typeFilter: "",
			filterSubText: null,
			contractNumberFilter: "",
			accountmanagerFilterOn: false,
			commercialFilterOn: false,
			deliveryFilterOn: false,
			societyFilterOn: false,
			statusFilterOn: false,
			isSentFilterOn: false,
			typeFilterOn: false,
			totalListLength: 0,
			contractNumberFilterOn: false,
			isLoading: false,
			displayedPendingInvoicesFull: [],
			displayedPendingInvoices: [],
			accountmanagerOptions: [],
			commercialOptions: [],
			deliveryOptions: [
				{ text: "SEO", value: 0 },
				{ text: "SEA", value: 1 },
				{ text: "E-Réputation", value: 2 },
				{ text: "Social Ads", value: 3 },
				{ text: "RP Digitale", value: 4 },
				{ text: "Formation", value: 5 },
				{ text: "Autre", value: 6 },
			],
			contractStatusOptions: [
				{ text: "Actif", value: 1 },
				{ text: "A\u00a0Valider", value: 2 },
				{ text: "En\u00a0pause", value: 3 },
				{ text: "Terminé", value: 4 },
				{ text: "Annulé", value: 5 },
			],
			typeOptions: [
				{ text: "Mensuel", value: 1 },
				{ text: "One Shot", value: 0 },
			],
			allPurchases: [],
			actionsTemplates: [],
			filtersTemplates: [
				{
					order: 1, // Filter order compared to others
					emitSlugName: "filter_contract",
					filterPlaceHolder: "N° de Contrat",
					value: "", // Consultant id
					type: "Input",
				},
				{
					order: 2,
					emitSlugName: "filter_client",
					filterPlaceHolder: "Client",
					value: "",
					type: "Input",
				},
				{
					order: 3,
					emitSlugName: "filter_status",
					filterPlaceHolder: "Statut (Sélection multiple)",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: true,
						dropdownValues: [
							{ name: "Actif", id: 1 },
							{ name: "A\u00a0Valider", id: 2 },
							{ name: "En\u00a0pause", id: 3 },
							{ name: "Terminé", id: 4 },
							{ name: "Annulé", id: 5 },
						],
					},
				},
				{
					order: 4,
					emitSlugName: "filter_commercial",
					filterPlaceHolder: "Commercial",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [],
					},
				},
				{
					order: 5,
					emitSlugName: "filter_consultant",
					filterPlaceHolder: "Consultant Lead",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [],
					},
				},
				{
					order: 6,
					emitSlugName: "filter_isSent",
					filterPlaceHolder: "",
					value: false,
					type: "Switch",
					params: {
						on: "Toutes les factures",
						off: "Factures à éditer",
					},
				},
			],
			refreshKey: 0,
		};
	},
	beforeRouteEnter(to, from, next) {
		// Save the previous route name in the session storage
		sessionStorage.setItem("prevRoute", from.name);
		next();
	},
	created() {
		this.checkToken();
		this.getAllTasks();
		this.getAllCollaborators();
		this.getAllSociety();
		this.getAllContractsWithContractsUsers();
		this.getAllPendingInvoices();
		this.filterSubText = `Résultat total: 0 / 0`;
	},
	mounted() {
		if (this.allCollaborators.length > 0) {
			this.createCommercialList();
			this.createAMList();
		}
		/*
		 * if(this.allContractsWithContractsUsers.length > 0){
		 * this.displayedPendingInvoicesFull = this.displayContracts(this.allContractsWithContractsUsers)
		 * this.displayedPendingInvoices = this.displayedPendingInvoicesFull
		 * if(sessionStorage.getItem("prevRoute") != "return_page"){
		 *   this.$router.push({ name: 'return_page' })
		 * }
		 * let contractId = sessionStorage.getItem("popupOrigin")
		 * //console.log("popup contractId", contractId)
		 * let foundContract = this.displayedPendingInvoicesFull.find(contract => contract.id == contractId)
		 * if(foundContract){
		 *   this.displayContractPopup(foundContract)
		 * }
		 * sessionStorage.removeItem("popupOrigin")
		 * this.createCommercialList()
		 * this.createAMList()
		 * }
		 */
	},
	watch: {
		accountmanagerFilter: function () {
			if (this.accountmanagerFilter == "") {
				this.accountmanagerFilterOn = false;
			} else {
				this.accountmanagerFilterOn = true;
			}
			this.refreshKey++;
			this.displayedPendingInvoices = this.filterPendingInvoices(
				this.displayedPendingInvoicesFull
			);
		},
		commercialFilter: function () {
			if (this.commercialFilter == "") {
				this.commercialFilterOn = false;
			} else {
				this.commercialFilterOn = true;
			}
			this.refreshKey++;
			this.displayedPendingInvoices = this.filterPendingInvoices(
				this.displayedPendingInvoicesFull
			);
		},
		// deliveryFilter: function() {
		// 	if(this.deliveryFilter == "") {
		// 		this.deliveryFilterOn = false;
		// 	}
		// 	else{
		// 		this.deliveryFilterOn = true;
		// 	}
		// 	this.refreshKey++;
		// 	this.displayedPendingInvoices = this.filterPendingInvoices(this.displayedPendingInvoicesFull);
		// },
		societyFilter: function () {
			if (this.societyFilter == "") {
				this.societyFilterOn = false;
			} else {
				this.societyFilterOn = true;
			}
			this.refreshKey++;
			this.displayedPendingInvoices = this.filterPendingInvoices(
				this.displayedPendingInvoicesFull
			);
		},
		contractNumberFilter: function () {
			if (this.contractNumberFilter == "") {
				this.contractNumberFilterOn = false;
			} else {
				this.contractNumberFilterOn = true;
			}
			this.refreshKey++;
			this.displayedPendingInvoices = this.filterPendingInvoices(
				this.displayedPendingInvoicesFull
			);
		},
		statusFilter: function () {
			if (this.statusFilter == "") {
				this.statusFilterOn = false;
			} else {
				this.statusFilterOn = true;
			}
			this.refreshKey++;
			this.displayedPendingInvoices = this.filterPendingInvoices(
				this.displayedPendingInvoicesFull
			);
		},
		isSentFilter: function (data) {
			this.isSentFilterOn = data;
			this.refreshKey++;
			this.displayedPendingInvoices = this.filterPendingInvoices(
				this.displayedPendingInvoicesFull
			);
		},
		// typeFilter: function() {
		// 	if(this.typeFilter == "") {
		// 		this.typeFilterOn = false;
		// 	}
		// 	else{
		// 		this.typeFilterOn = true;
		// 	}
		// 	this.refreshKey++;
		// 	this.displayedPendingInvoices = this.filterPendingInvoices(this.displayedPendingInvoicesFull);
		// },
		// /*
		//  * allContracts: function(){
		//  *   this.displayedPendingInvoicesFull = this.displayContracts(this.allContracts)
		//  *   this.displayedPendingInvoices = this.displayedPendingInvoicesFull
		//  * },
		//  */
		// allContractsWithContractsUsers: function(data){
		// 	if(data.length > 0){
		// 		this.displayedPendingInvoicesFull = this.displayContracts(data);
		// 		this.displayedPendingInvoices = this.displayedPendingInvoicesFull;
		// 		let contractId = sessionStorage.getItem("popupOrigin");
		// 		if(contractId){
		// 			//console.log("popup contractId", contractId);
		// 			let foundContract = this.displayedPendingInvoicesFull.find(contract => contract.id == contractId);
		// 			if(foundContract){
		// 				this.displayContractPopup(foundContract);
		// 			}
		// 			sessionStorage.removeItem("popupOrigin");
		// 		}
		// 	}
		// },
		allCollaborators: function (data) {
			let foundCommercialFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_commercial"
			);
			if (foundCommercialFilterId) {
				this.filtersTemplates[foundCommercialFilterId].params.dropdownValues =
					data
						.filter((collaborator) => [4, 6, 9].includes(collaborator.type))
						.sort((a, b) => {
							return a["firstname"].localeCompare(b["firstname"]); //using String.prototype.localCompare()
						})
						.map((row) => {
							return { id: row.id, name: row.firstname + " " + row.lastname };
						});
			}
			let foundConsultantFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_consultant"
			);
			if (foundConsultantFilterId) {
				this.filtersTemplates[foundConsultantFilterId].params.dropdownValues =
					data
						.filter((collaborator) => [3, 6, 7, 9].includes(collaborator.type))
						.sort((a, b) => {
							return a["firstname"].localeCompare(b["firstname"]); //using String.prototype.localCompare()
						})
						.map((row) => {
							return { id: row.id, name: row.firstname + " " + row.lastname };
						});
			}
		},
	},
	computed: {
		/*
		 * allContracts: () => {
		 *   return store.state.contracts;
		 * },
		 */
		allSocieties: () => {
			return store.state.societies;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allContractsUsers: () => {
			return store.state.contracts_users;
		},
		allContractsWithContractsUsers: () => {
			return store.state.contracts_contracts_users;
		},
		today: () => {
			return new Date(Date.now());
		},
		tasks: () => {
			return store.state.tasks;
		},
	},

	methods: {
		async resetAllFilter() {
			this.accountmanagerFilter = "";
			this.commercialFilter = "";
			this.deliveryFilter = "";
			this.isSentFilter = false;
			this.societyFilter = "";
			this.statusFilter = [];
			this.typeFilter = "";
			this.contractNumberFilter = "";
			this.accountmanagerFilterOn = false;
			this.commercialFilterOn = false;
			this.deliveryFilterOn = false;
			this.societyFilterOn = false;
			this.statusFilterOn = false;
			this.isSentFilterOn = false;
			this.typeFilterOn = false;
			this.contractNumberFilterOn = false;
			this.filterPendingInvoices(this.displayedPendingInvoicesFull);
		},
		checkToken() {
			this.$http
				.get(this.apiUrl + "qb/check")
				.then((result) => {
					if (result) {
						return true;
					}
				})
				.catch((err) => {
					//console.log(err);
					return false;
				});
		},
		displaySocietyPopup(societyId) {
			//Initialisation des données pour le popup
			this.selectedSociety = null; // Always reset data before assigning it
			let foundSociety = this.allSocieties.findIndex(
				(row) => row.id == societyId
			);
			if (foundSociety < 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Société introuvable, contactez l'équipe technique.",
				});
				return false;
			}
			this.selectedSociety = this.allSocieties[foundSociety];
			this.showSocietyPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		modifyPurchase(purchase) {
			// //console.log("modifyPurchase");
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: { purchaseId: purchase.id, updateEntityForm: "purchases" },
			});
		},
		renewPurchase(purchaseId) {
			// //console.log("renewPurchase");
			this.showContractPopup = false;
			this.$router.push({
				name: "new_entity",
				params: { purchaseId: purchaseId, newEntityForm: "renewpurchase" },
			});
		},

		/**
		 * Query our API to fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocietiesIdAndName");
		},

		/**
		 * Query our API to fetch all rankwell collaborators
		 */
		getAllCollaborators() {
			this.$store.dispatch("getAllCollaborators");
		},

		/**
		 * Query our API to fetch all the rankwell collaborators avatar
		 */
		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},

		/**
		 * Query our API to fetch all the contracts with contracts users
		 */
		getAllContractsWithContractsUsers() {
			this.$store.dispatch("getAllContractsWithContractsUsers");
		},

		getAllSociety() {
			this.$store.dispatch("getAllSocieties");
		},

		/**
		 * Query our API to fetch all tasks
		 */
		getAllTasks() {
			this.$store.dispatch("getAllTasks");
		},

		getAllPendingInvoices() {
			this.isLoading = true;
			this.$http
				.get(this.apiUrl + "pending_invoices/invoices/all")
				.then((result) => {
					this.displayedPendingInvoicesFull = result.data;
					this.totalListLength = result.data.length;
					this.displayedPendingInvoices = this.filterPendingInvoices(
						result.data
					);

					this.isLoading = false;
				})
				.catch((err) => {
					this.displayedPendingInvoicesFull = [];
					this.isLoading = false;
					//console.log(err);
				});
		},

		/**
		 * Query our API to fetch all the contracts users
		 */
		getAllContractsUsers() {
			this.$store.dispatch("getAllContractsUsers");
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit) {
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == receivedEmit[0]
			);
			if (templateRowIndex >= 0)
				this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch (receivedEmit[0]) {
				case "filter_client":
					this.societyFilter = receivedEmit[1].value;
					break;
				case "filter_contract":
					this.contractNumberFilter = receivedEmit[1].value;
					break;
				case "filter_status":
					this.statusFilter = receivedEmit[1].value;
					break;
				case "filter_commercial":
					this.commercialFilter = receivedEmit[1].value;
					break;
				case "filter_consultant":
					this.accountmanagerFilter = receivedEmit[1].value;
					break;
				case "filter_isSent":
					this.isSentFilter = receivedEmit[1].value;
					break;
				default:
					break;
			}
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			// switch(receivedEmit[0]){
			// case"action_extract_contract":
			// 	this.exportData(this.displayedContracts);
			// 	break;
			// case"new_contract":
			// 	// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
			// 	this.$router.push({name: "new_entity"});
			// 	break;
			// default:
			// 	break;
			// }
		},

		/**
		 * Query API to fetch all the existing contracts
		 * Sorted from the latest to the oldest
		 */
		createAMList() {
			let foundConsultantFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_consultant"
			);
			if (foundConsultantFilterId)
				this.filtersTemplates[foundConsultantFilterId].params.dropdownValues =
					this.sortABC(
						this.allCollaborators.filter((collaborator) =>
							[3, 6, 9].includes(collaborator.type)
						),
						"firstname"
					).map((row) => {
						return { id: row.id, name: row.firstname + " " + row.lastname };
					});
		},

		createCommercialList() {
			let foundCommercialFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_commercial"
			);
			if (foundCommercialFilterId)
				this.filtersTemplates[foundCommercialFilterId].params.dropdownValues =
					this.sortABC(
						this.allCollaborators.filter((collaborator) =>
							[4, 6, 9].includes(collaborator.type)
						),
						"firstname"
					).map((row) => {
						return { id: row.id, name: row.firstname + " " + row.lastname };
					});
		},

		isFilterSet() {
			////console.log("isFilterSet BEGIN")
			if (
				this.accountmanagerFilterOn ||
				this.commercialFilterOn ||
				this.deliveryFilterOn ||
				this.societyFilterOn ||
				this.typeFilterOn ||
				this.contractNumberFilterOn ||
				this.statusFilterOn ||
				!this.isSentFilterOn
			)
				return true;
			return false;
		},

		/**
		 * Return list of filtered netlink A CHANGER
		 * @param {String} deliveryFilter - Type of delivery
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} contractNumberFilter - Contract Id filter
		 * @param {String} statusFilter - Contract status filter
		 * @return {List} - Societies' list filtered
		 */
		filterPendingInvoices(contract) {
			////console.log("filterProviders BEGIN")
			let contractList = [];
			let searchKeyList = {};

			if (this.statusFilterOn) {
				searchKeyList["statusFilter"] = this.statusFilter;
			}
			// if(this.deliveryFilterOn){
			// 	searchKeyList["deliveryFilter"] = this.deliveryFilter;
			// }

			this.accountmanagerFilterOn
				? (searchKeyList["accountmanagerFilter"] = this.accountmanagerFilter)
				: false;
			this.commercialFilterOn
				? (searchKeyList["commercialFilter"] = this.commercialFilter)
				: false;
			this.societyFilterOn
				? (searchKeyList["societyFilter"] = this.societyFilter.toLowerCase())
				: false;
			// this.typeFilterOn ? searchKeyList["typeFilter"] = this.typeFilter : false;
			this.contractNumberFilterOn
				? (searchKeyList["contractNumberFilter"] = this.contractNumberFilter)
				: false;
			this.isSentFilterOn
				? (searchKeyList["isSentFilter"] = this.isSentFilter ? "0" : "1")
				: false;

			// //console.log("searchKeyList", searchKeyList);
			for (let pendingInvoiceToFilter of contract) {
				////console.log(netlinkToFilter)
				let society_name = pendingInvoiceToFilter.society_name;

				if (society_name != "") society_name = society_name.toLowerCase();

				let contractSearchKeyList = {};
				// if(this.accountmanagerFilterOn){
				// 	if(pendingInvoiceToFilter.account_manager_name){
				// 		contractSearchKeyList["accountmanagerFilter"] = pendingInvoiceToFilter.account_manager_name.split(", ");
				// 	}
				// }
				this.accountmanagerFilterOn &&
				pendingInvoiceToFilter.account_manager_ids
					? (contractSearchKeyList["accountmanagerFilter"] =
							pendingInvoiceToFilter.account_manager_ids.map((row) => row.id))
					: false;
				this.commercialFilterOn
					? (contractSearchKeyList["commercialFilter"] =
							pendingInvoiceToFilter.commercial_id)
					: false;
				this.societyFilterOn
					? (contractSearchKeyList["societyFilter"] = society_name)
					: false;
				// this.deliveryFilterOn ? contractSearchKeyList["deliveryFilter"] = pendingInvoiceToFilter.delivery : false;
				this.contractNumberFilterOn
					? (contractSearchKeyList["contractNumberFilter"] =
							pendingInvoiceToFilter.contract_id.toString())
					: false;
				// this.typeFilterOn ? contractSearchKeyList["typeFilter"] = pendingInvoiceToFilter.type : false;
				this.statusFilterOn
					? (contractSearchKeyList["statusFilter"] =
							pendingInvoiceToFilter.contract_status)
					: false;
				//console.log("FILTER SINR", this.isSentFilterOn);
				this.isSentFilterOn
					? (contractSearchKeyList["isSentFilter"] = String(
							pendingInvoiceToFilter.is_sent
					  ))
					: false;

				let check = true;

				for (let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof contractSearchKeyList[key])
					 */
					if (typeof searchKeyList[key] == "string") {
						if (typeof contractSearchKeyList[key] == "string") {
							if (!contractSearchKeyList[key].includes(searchKeyList[key])) {
								check = false;
								break;
							}
						} else if (typeof contractSearchKeyList[key] == "object") {
							////console.log("Array")
							let checkLoop = false;
							for (let value of contractSearchKeyList[key]) {
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if (service_name.includes(searchKeyList[key])) {
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if (!checkLoop) {
								check = checkLoop;
								break;
							}
						}
					} else {
						if (Array.isArray(contractSearchKeyList[key])) {
							// //console.log("contractSearchKeyList[key]",contractSearchKeyList[key])
							let searchKey = searchKeyList[key];
							// //console.log(searchKey)
							let stringSearchKey = searchKey.toString();
							if (!contractSearchKeyList[key].includes(stringSearchKey)) {
								check = false;
								break;
							}
						} else {
							if (Array.isArray(searchKeyList[key])) {
								let searchKey = searchKeyList[key].map((value) => value);
								if (!searchKey.includes(contractSearchKeyList[key])) {
									check = false;
									break;
								}
							} else {
								let searchKey = searchKeyList[key];
								if (contractSearchKeyList[key] != searchKey) {
									check = false;
									break;
								}
							}
						}
					}
				}

				if (check) contractList.push(pendingInvoiceToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			// Setting subtext for filter here
			this.filterSubText = `Résultat total: ${contractList.length} / ${this.totalListLength}`;
			return contractList;
		},

		contractPopupFormating(contract) {
			if (contract) {
				let account_manager_avatars = [];
				if ("account_managers" in contract) {
					let contract_account_managers_names =
						contract.account_managers !== null
							? contract.account_managers.split(", ")
							: [];
					let contract_account_managers =
						contract_account_managers_names.splice(
							0,
							contract_account_managers_names.length / 2
						);
					for (let i = 0; i < contract_account_managers.length; i++) {
						account_manager_avatars.push({
							name: contract_account_managers_names[i],
							users_id: contract_account_managers[i],
							is_lead: contract.lead_am == contract_account_managers[i] ? 1 : 0,
						});
					}
				}
				contract.account_manager_avatars =
					account_manager_avatars.length > 0
						? account_manager_avatars
						: { name: "", is_lead: 0 };
				/*
				 * Format start and end dates
				 * Set type name
				 */
				contract.type_name = this.getContractTypeName(contract.type);
				//Set type name
				contract.delivery_name = this.getProductCategoryName(contract.delivery);
				//Set status type
			}
			return contract;
		},

		/**
		 * Triggered on click
		 * Display the pop including all informations about a contract
		 */
		displayContractPopup(contract_id) {
			this.selectedContract = null;
			let foundContract = this.allContractsWithContractsUsers.findIndex(
				(row) => row.id == contract_id
			);
			if (foundContract < 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Contrat introuvable, contactez l'équipe technique.",
				});
				return false;
			}
			this.selectedContract =
				this.allContractsWithContractsUsers[foundContract];
			this.showContractPopup = true;

			let formatedContract = this.contractPopupFormating(this.selectedContract);
			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ContractInfoPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					contract: formatedContract,
					popupActive: this.showContractPopup,
					router: this.$router,
					// apiUrl: this.apiUrl
				},
			});
			// @modify-contract="modifyContract($event)"
			contractPopup.$mount();
			contractPopup.$on("modify-contract", (contractId) => {
				this.popupActive = false;
				this.modifyContract(contractId);
			});
			contractPopup.$on("modify-missions", (contractId) => {
				this.popupActive = false;
				this.modifyMissions(contractId);
			});
			contractPopup.$on("modify-purchase", (purchase) => {
				this.popupActive = false;
				this.modifyPurchase(purchase);
			});
			contractPopup.$on("renew-purchase", (purchaseId) => {
				this.popupActive = false;
				this.renewPurchase(purchaseId);
			});

			this.$refs.popupContainer.appendChild(contractPopup.$el);
		},

		displayDocumentPopup(id) {
			this.$http
				.get(this.apiUrl + "contracts_documents/list/contract/" + id)
				.then((res) => {
					if (res.data.length > 0) {
						this.showContractPopup = true;

						let ComponentClass = Vue.extend(ContractDocumentsListTable);
						let documentPopup = new ComponentClass({
							propsData: {
								contract_id: id,
								contract_documents: res.data,
								popupActive: this.showContractPopup,
							},
						});
						documentPopup.$mount();

						this.$refs.popupContainer.appendChild(documentPopup.$el);
					}
				});
		},

		modifyContract(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 0,
					updateEntityForm: "contracts",
				},
			});
		},

		modifyMissions(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 1,
					updateEntityForm: "contracts_missions",
				},
			});
		},

		removeLine(contract) {
			/*
			 * this.$vs.notify({
			 *   title: "En cours de développement",
			 *   text: "La fonctionalité sera bientôt disponible."
			 * });
			 * let contractToDelete = this.displayedPendingInvoicesFull.find(element => element.id == contract.id)
			 */
			this.displayedPendingInvoicesFull =
				this.displayedPendingInvoicesFull.filter(function (element) {
					return element.id != contract.id;
				});
			this.displayedPendingInvoices = this.displayedPendingInvoicesFull;
		},

		getSocietyName(societyId) {
			let society_name = "";
			let society = this.allSocieties.find(
				(society) => society.id == societyId
			);
			/*
			 * //console.log("society")
			 * //console.log(JSON.stringify(society))
			 */
			society_name = society ? society.name : " ";
			return society_name;
		},

		getUserName(userId) {
			let user_name = "";
			/*
			 * //console.log("userId", userId)
			 * //console.log("this.allCollaborators", this.allCollaborators)
			 */
			let user = this.allCollaborators.find((user) => user.id == userId);
			user_name = user ? user.firstname + " " + user.lastname : " ";
			return user_name;
		},

		getIsLead(userId, contractId) {
			let is_lead = "";
			//Find collaborator is_lead in contract_users
			let user_contracts_list = this.allContractsUsers.filter(
				(user) => user.users_id == userId
			);
			let user = user_contracts_list.find(
				(contract) => contract.contracts_id == contractId
			);
			if (user.is_lead == 1) {
				return 1;
			}
			return is_lead;
		},

		createContractList(contracts_contracts_users) {
			let contract_id = null;
			let contract_list = [];
			let account_managers = [];
			let prec_row = null;
			for (let row of contracts_contracts_users) {
				if (contract_id == row.id) {
					account_managers.push({
						user_id: row.users_id,
						type: row.type,
						is_lead: row.is_lead,
					});
				} else {
					if (account_managers.length > 0) {
						prec_row.account_managers = JSON.parse(
							JSON.stringify(account_managers)
						);
					}

					if (prec_row == null) {
						prec_row = row;
						contract_id = row.id;
					} else {
						contract_list.push(JSON.parse(JSON.stringify(prec_row)));
						account_managers = [];
						contract_id = row.id;
						prec_row = row;
					}
				}
			}
			if (account_managers.length > 0) {
				prec_row.account_managers = JSON.parse(
					JSON.stringify(account_managers)
				);
			}
			contract_list.push(JSON.parse(JSON.stringify(prec_row)));

			return contract_list;
		},

		displayContracts(contracts) {
			// let testContractList = this.createContractList(this.allContractsWithContractsUsers)

			let contractsList = [];
			if (this.displayedPendingInvoices.length > 0) {
				contractsList = this.displayedPendingInvoices;
			} else {
				// if(!this.isFilterSet()){
				contractsList = contracts;
				// }
			}
			if (contractsList.length > 0) {
				for (let contract of contractsList) {
					if (contract == null) {
						continue;
					}
					/*
					 *  //console.log("contract", contract)
					 *  //console.log(contract)
					 * Set society name
					 *  contract.society_name = this.getSocietyName(contract.society_id)
					 * Set commercial and account manager names (firstname + lastname)
					 *  contract.commercial_name = contract.commercial_id != null ? this.getUserName(contract.commercial_id) : " "
					 */
					let account_manager_avatars = [];
					// let account_managers_list = []
					if ("account_managers" in contract) {
						let contract_account_managers_names =
							contract.account_managers !== null
								? contract.account_managers.split(", ")
								: [];
						let contract_account_managers =
							contract_account_managers_names.splice(
								0,
								contract_account_managers_names.length / 2
							);
						for (let i = 0; i < contract_account_managers.length; i++) {
							account_manager_avatars.push({
								name: contract_account_managers_names[i],
								users_id: contract_account_managers[i],
								is_lead:
									contract.lead_am == contract_account_managers[i] ? 1 : 0,
							});
						}
						/*
						 * for(let collaborator of contract_account_managers){
						 *   account_manager_avatars.push({
						 *     name: this.getUserName(collaborator),
						 *     users_id: collaborator,
						 *     is_lead: contract.lead_am == collaborator ? 1 : 0
						 *   })
						 * }
						 */
					}
					contract.account_manager_avatars =
						account_manager_avatars.length > 0
							? account_manager_avatars
							: { name: "", is_lead: 0 };
					/*
					 * Format start and end dates
					 * Set type name
					 */
					contract.type_name = this.getContractTypeName(contract.type);
					//Set type name
					contract.delivery_name = this.getProductCategoryName(
						contract.delivery
					);
					//Set status type
				}
			}
			return contractsList;
		},

		getYearFromMonth(month) {
			let year =
				month >= 0 ? this.today.getFullYear() : this.today.getFullYear() - 1;
			return year.toString().substring(2, 4);
		},

		exportData(data) {
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Contrats";

			let header = {
				header: [
					"id",
					"society_name",
					"delivery_name",
					"type_name",
					"status",
					"start_date",
					"end_date",
					"commercial_name",
					"account_managers",
					"estimate_link",
					"cumul_curr_month",
					"refac_curr_month",
					"task_curr_total",
					"task_curr_done",
					"cumul_last_month",
					"refac_last_month",
					"task_last_total",
					"task_last_done",
					"cumul_last_last_month",
					"refac_last_last_month",
					"task_last_last_total",
					"task_last_last_done",
					"max_budget",
					"max_price_netlink",
					"commentary",
					"detail",
				],
				skipHeader: true,
				origin: -1,
			};
			// Ajouter date des mois dans les header
			let formated_data = [];
			let actual_date = new Date(Date.now());
			let actual_month = actual_date.getMonth();
			let actual_year = actual_date.getFullYear();

			let date_last_month = new Date(actual_date);
			date_last_month.setMonth(actual_date.getMonth() - 1);

			let date_last_last_month = new Date(actual_date);
			date_last_last_month.setMonth(actual_date.getMonth() - 2);

			let header_names = [
				{
					id: "N° de contrat",
					society_name: "Client",
					delivery_name: "Type",
					type_name: "Mensualisation",
					status: "Statut",
					start_date: "Date début",
					end_date: "Date de fin",
					commercial_name: "Commercial",
					account_managers: "Consultants",
					estimate_link: "Lien devis",
					cumul_curr_month: `Montant Total ${
						actual_date.getMonth() + 1
					}/${actual_date.getFullYear()}`,
					refac_curr_month: `Montant facturable ${
						actual_date.getMonth() + 1
					}/${actual_date.getFullYear()}`,
					task_curr_total: `Tâches total ${
						actual_date.getMonth() + 1
					}/${actual_date.getFullYear()}`,
					task_curr_done: `Tâches effectuées ${
						actual_date.getMonth() + 1
					}/${actual_date.getFullYear()}`,
					cumul_last_month: `Montant Total ${
						date_last_month.getMonth() + 1
					}/${date_last_month.getFullYear()}`,
					refac_last_month: `Montant facturable  ${
						date_last_month.getMonth() + 1
					}/${date_last_month.getFullYear()}`,
					task_last_total: `Tâches total ${
						date_last_month.getMonth() + 1
					}/${date_last_month.getFullYear()}`,
					task_last_done: `Tâches effectuées ${
						date_last_month.getMonth() + 1
					}/${date_last_month.getFullYear()}`,
					cumul_last_last_month: `Montant Total ${
						date_last_last_month.getMonth() + 1
					}/${date_last_last_month.getFullYear()}`,
					refac_last_last_month: `Montant facturable  ${
						date_last_last_month.getMonth() + 1
					}/${date_last_last_month.getFullYear()}`,
					task_last_last_total: `Tâches total ${
						date_last_last_month.getMonth() + 1
					}/${date_last_last_month.getFullYear()}`,
					task_last_last_done: `Tâches effectuées ${
						date_last_last_month.getMonth() + 1
					}/${date_last_last_month.getFullYear()}`,
					max_budget: "Budget Max",
					max_price_netlink: "Prix Max du Netlink",
					commentary: "Commentaire facturation",
					detail: "Commentaire",
					// account_manager_join:"Consultant",
				},
			];
			/*
			 * Ajouter account_manager_avatars.join()
			 * Ajouter mois en cours
			 * Ajouter mois dernier
			 */

			///////////// PURCHASE /////////////
			for (let row of data) {
				let actualMonthSum = 0;
				let actualMonthRefac = 0;
				let lastMonthSum = 0;
				let lastMonthRefac = 0;
				let lastLastMonthSum = 0;
				let lastLastMonthRefac = 0;
				//Filtrer les achats sur le numéro de contrat
				let contract_purchases = this.allPurchases.filter(
					(purchase) => purchase.contract_id == row.id
				);

				for (let purchase of contract_purchases) {
					let purchase_date =
						purchase.recurrence > 0
							? new Date(purchase.recurrence_date)
							: new Date(purchase.bought_at);
					let purchase_month = purchase_date.getMonth();
					let purchase_year = purchase_date.getFullYear();

					if (actual_year == purchase_year && actual_month == purchase_month) {
						let totalAndRefac = this.addTotalHTAndRefac(purchase);
						actualMonthSum += totalAndRefac.total;
						actualMonthRefac += totalAndRefac.refac;
					}

					if (
						date_last_month.getFullYear() == purchase_year &&
						date_last_month.getMonth() == purchase_month
					) {
						let totalAndRefac = this.addTotalHTAndRefac(purchase);
						lastMonthSum += totalAndRefac.total;
						lastMonthRefac += totalAndRefac.refac;
					}

					if (
						date_last_last_month.getFullYear() == purchase_year &&
						date_last_last_month.getMonth() == purchase_month
					) {
						let totalAndRefac = this.addTotalHTAndRefac(purchase);
						lastLastMonthSum += totalAndRefac.total;
						lastLastMonthRefac += totalAndRefac.refac;
					}
				}
				///////////// PURCHASE /////////////

				///////////// TASKS /////////////
				let currentTasks = this.getMonthTasks(
					this.getYearFromMonth(this.today.getMonth()),
					this.today.getMonth(),
					row.id
				);
				let currentMonthTasks = currentTasks.tasks;
				let currentTaskDone = currentTasks.done;
				let currentTaskTotal = currentMonthTasks.length;

				let lastTasks = this.getMonthTasks(
					this.getYearFromMonth(this.today.getMonth() - 1),
					this.getSubstractedMonth(this.today.getMonth(), 1),
					row.id
				);
				let lastMonthTasks = lastTasks.tasks;
				let lastMonthTaskDone = lastTasks.done;
				let lastMonthTaskTotal = lastMonthTasks.length;

				let lastLastTasks = this.getMonthTasks(
					this.getYearFromMonth(this.today.getMonth() - 2),
					this.getSubstractedMonth(this.today.getMonth(), 2),
					row.id
				);
				let lastLastMonthTasks = lastLastTasks.tasks;
				let lastLastMonthTaskDone = lastLastTasks.done;
				let lastLastMonthTaskTotal = lastLastMonthTasks.length;
				///////////// TASKS /////////////

				formated_data.push({
					id: row.id,
					delivery_name: row.delivery_name,
					commercial_name: row.commercial_name,
					commentary: row.commentary,
					detail: row.detail,
					end_date: row.end_date
						? row.end_date.substring(0, 10).split("-").reverse().join("/")
						: null,
					estimate_link: row.estimate_link,
					max_budget: row.max_budget,
					max_price_netlink: row.max_price_netlink,
					society_name: row.society_name,
					start_date: row.start_date
						? row.start_date.substring(0, 10).split("-").reverse().join("/")
						: null,
					status: this.getContractStatus(row.status),
					type_name: row.type_name,
					account_managers:
						row.account_manager_avatars.length > 0
							? row.account_manager_avatars
									.map((account_manager) => account_manager.name)
									.join(", ")
							: null,
					cumul_curr_month: actualMonthSum,
					refac_curr_month: actualMonthRefac,
					cumul_last_month: lastMonthSum,
					refac_last_month: lastMonthRefac,
					cumul_last_last_month: lastLastMonthSum,
					refac_last_last_month: lastLastMonthRefac,

					task_curr_total: currentTaskTotal,
					task_curr_done: currentTaskDone,
					task_last_total: lastMonthTaskTotal,
					task_last_done: lastMonthTaskDone,
					task_last_last_total: lastLastMonthTaskTotal,
					task_last_last_done: lastLastMonthTaskDone,
					// account_manager_join:"Account manager",
				});
			}

			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, formated_data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Contrats_export.xls");
		},
	},
};
</script>

<style lang="scss">
.fw-bold {
	font-weight: bold;
	color: black;
}

.center {
	justify-content: center;
}

.table-filter {
	.con-tablex.vs-table--content {
		.vs-con-tbody.vs-table--tbody > table {
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead {
				display: none;
			}
			tr {
				.td-check {
					width: 40px;
				}
				td {
					border: none;
				}
			}
			.tr-expand > td > div {
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table {
				display: none;
			}
		}
		.not-data-table.vs-table--not-data {
			display: none;
		}
	}
}
</style>
